export const getQueryPath = (query:Record<string, string | number | boolean | string[]>): string => {
    const queryString = Object.entries(query)
      .filter(([, value]) => value !== undefined && value !== null)
      .map(([key, value]) => {
        if (Array.isArray(value)) {
          return `${key}=${value.map((v) => encodeURIComponent(String(v))).join(',')}`;
        }
        return `${key}=${encodeURIComponent(String(value))}`;
      })
      .join('&');
  
    return queryString;
  };